import { render, staticRenderFns } from "./limit-editor.vue?vue&type=template&id=0205831c&scoped=true"
import script from "./limit-editor.vue?vue&type=script&lang=js"
export * from "./limit-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205831c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0205831c')) {
      api.createRecord('0205831c', component.options)
    } else {
      api.reload('0205831c', component.options)
    }
    module.hot.accept("./limit-editor.vue?vue&type=template&id=0205831c&scoped=true", function () {
      api.rerender('0205831c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/limit-editor.vue"
export default component.exports